import { poe2 } from '../../game';
import { cantHaveSocketsItemClasses, itemTypesWithTwoSockets } from '../data/poe2/item-lists';
import { Rarity } from '../models/enums';
import { GameItem } from '../models/game-item.models';

export type GearQualityPrefix = 'Superior' | 'Exceptional';

export function hasExtraSocket(item: GameItem): boolean {
  if (!poe2 || item.sockets === undefined || item.sockets <= 0) return false;
  if (cantHaveSocketsItemClasses.includes(item.itemClass)) return false;

  const maxNormalSockets = itemTypesWithTwoSockets.includes(item.itemClass) ? 2 : 1;
  return item.sockets > maxNormalSockets;
}

export function getGearQualityPrefix(item: GameItem): GearQualityPrefix | null {
  if (poe2) {
    if (item.quality !== undefined && item.quality >= 21) return 'Exceptional';
    if (hasExtraSocket(item)) return 'Exceptional';
    if (item.quality !== undefined && item.quality >= 1) return 'Superior';
    return null;
  }

  if (item.quality !== undefined && item.quality >= 1) return 'Superior';
  return null;
}

function hasQualityPrefix(name: string): boolean {
  return name.startsWith('Superior ') || name.startsWith('Exceptional ');
}

export function getGameItemExampleName(item: GameItem): string {
  const isRareOrIdentifiedUnique =
    item.rarity === Rarity.Rare || (item.rarity === Rarity.Unique && item.identified !== false);

  if (isRareOrIdentifiedUnique) {
    return item.baseType;
  }

  if (item.rarity !== Rarity.Normal) {
    return item.name ?? item.baseType;
  }

  if (item.name && hasQualityPrefix(item.name)) {
    return item.name;
  }

  const prefix = getGearQualityPrefix(item);
  if (prefix) {
    return `${prefix} ${item.baseType}`;
  }

  return item.name ?? item.baseType;
}
